import { IconButton, MenuItem, Popover, Typography } from '@mui/material';
import {
  bindPopover,
  bindTrigger,
  usePopupState,
} from 'material-ui-popup-state/hooks';
import { useNavigate } from 'react-router';
import type { IChatConversation } from 'src/@types/chat';
import { routes } from 'src/Router';
import { useConfirmationModal } from 'src/components/ConfirmationModal';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';
import { useDeleteChannel } from '../shared/ChatOverviewDialog/OverviewTabs/ChatDelete/useDeleteChannel';
import { useChatAllowedAction } from '../shared/useChatAllowedAction';

type Props = {
  conversation: IChatConversation;
};

export const DeleteThreadPopover = ({ conversation }: Props) => {
  const navigate = useNavigate();
  const { translate } = useLocales();
  const { confirm } = useConfirmationModal();
  const { canDeleteChannel } = useChatAllowedAction({ conversation });
  const { deleteChannel, isDeletingChannel } = useDeleteChannel();

  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'deleteThreadPopover',
  });

  const handelDeleteThread = async () => {
    if (
      !(await confirm({
        title: translate('shared.confirmation.are_you_sure_title'),
        message: translate('shared.confirmation.are_you_sure_delete'),
      }))
    )
      return;
    await deleteChannel(conversation._id);
    navigate(routes.dashboard.chat.root);
  };

  return (
    <>
      <IconButton
        {...bindTrigger(popupState)}
        disabled={!canDeleteChannel}
        size="small"
      >
        <Iconify icon="tabler:dots-vertical" />
      </IconButton>
      <Popover
        {...bindPopover(popupState)}
        onClose={() => popupState.close()}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={handelDeleteThread}
          disabled={isDeletingChannel}
          sx={{ color: 'error.main', gap: 1 }}
        >
          <Iconify icon="tabler:trash" />

          <Typography>
            {translate('communicate.thread.delete_thread')}
          </Typography>
        </MenuItem>
      </Popover>
    </>
  );
};
